// ===========================================
// Export Hooks
// ===========================================
// React Query mutation hook for school data export

import { useMutation } from '@tanstack/react-query';
import { downloadExport, type ExportParams } from '../api/export.api';

/**
 * Download exported school data as a file.
 */
export function useExportDownload() {
  return useMutation<void, Error, ExportParams>({
    mutationFn: downloadExport,
  });
}
